import { createSelector } from 'reselect';
import { THEME_KEY } from './constants';

const getTheme = state => state[THEME_KEY];

export const getThemeParameters = createSelector(
    getTheme,
    theme => theme,
);
